import React from "react"
import { FloatingActionButton, Table, TableBody, TableRow, TableRowColumn, Chip } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IPunchRule, IPunchRulesSettings } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import AddPunchRuleDialog from "./AddPunchRuleDialog"
import _ from "lodash"
import * as permissionHelper from "../../helpers/permissionHelper"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    readonly?: boolean
    isRoot?: boolean
    overridden?: boolean
    settingObj?: IPunchRulesSettings
    handleChangeSettingObj?(settingObj: IPunchRulesSettings): void
}
interface IState {
    openAddPunchRuleDialog: boolean
    hoveredPunchRule: IPunchRule
}

export default class HierarchySettingsPunchRules extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openAddPunchRuleDialog: false,
            hoveredPunchRule: null
        }
        autobind(this)
    }

    handleChangeValue(punchRules: IPunchRule[]) {
        const { settingObj } = this.props
        settingObj.PunchRules = punchRules
        this.props.handleChangeSettingObj(settingObj)
    }

    render() {
        const punchRules: IPunchRule[] = _.cloneDeep((this.props.settingObj && this.props.settingObj.PunchRules) || [])
        const editable = this.props.isRoot || this.props.overridden
        const readonly = this.props.readonly || !(permissionHelper.isAccountManager() || permissionHelper.isGlobalAdmin())
        return (
            <div>
                {!readonly && editable &&
                    <FloatingActionButton
                        data-intercom-target={"menu-Hierarchy-Settings-PunchRules-Btn-Add"}
                        style={{ position: "absolute", right: 42, display: "inline-block", zIndex: 100, top: -20 }}
                        mini={true}
                        secondary={true}
                        onTouchTap={() => this.setState({ openAddPunchRuleDialog: true, hoveredPunchRule: null })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                {!punchRules.length ?
                    strings.There_is_no_Punch_Rule_item :
                    <Table
                        multiSelectable={false}
                        selectable={false}
                        fixedHeader={true}
                        style={{ backgroundColor: "none", borderBottom: "1px solid rgb(224,224,224)", borderTop: "1px solid rgb(224,224,224)" }}
                        onRowHover={rowNumber =>
                            this.setState({ hoveredPunchRule: punchRules[rowNumber] })
                        }
                    >
                        <TableBody showRowHover={editable} deselectOnClickaway={false} displayRowCheckbox={false}>
                            {punchRules.map((row, i) =>
                                <TableRow key={i} style={{ heigth: 45 }}>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {row.Description ? `${row.Name} - ${row.Description}` : row.Name}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "right", paddingLeft: 0, width: 180 }}>
                                        {row.DailyRule &&
                                            <Chip style={{ margin: 2, height: 35, width: "min-content" }}>
                                                {strings.Daily_Punch_Rule}
                                            </Chip>
                                        }
                                        {row.FullTimecard &&
                                            <Chip style={{ margin: 2, height: 35, width: "min-content" }}>
                                                {strings.Full_Timecard_Punch_Rules.slice(0, -1)}
                                            </Chip>
                                        }
                                    </TableRowColumn>
                                    {AccountStore.getPunchRuleStageEnabled() &&
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 5, paddingRight: 5, width: 50 }}>
                                            {`Stage ${row.Stage}`}
                                        </TableRowColumn>
                                    }
                                    {!readonly && editable &&
                                        <TableRowColumn style={{ width: 40, cursor: "pointer" }} className="prevent-cell-click">
                                            {this.state.hoveredPunchRule && this.state.hoveredPunchRule.Id === row.Id &&
                                                <div onClick={e => e.stopPropagation()}>
                                                    <i
                                                        data-intercom-target={i === 0 && "menu-Hierarchy-Settings-PunchRuleRow-Btn-OpenEditItemDialog"}
                                                        className="fa fa-pencil"
                                                        style={{ fontSize: 20, fontWeight: "bold", cursor: "pointer" }}
                                                        onClick={() => this.setState({ openAddPunchRuleDialog: true })}
                                                    />
                                                    <i
                                                        data-intercom-target={i === 0 && "menu-Hierarchy-Settings-PunchRuleRow-Btn-OpenRemoveItemDialog"}
                                                        className="fa fa-trash-o"
                                                        style={{ fontSize: 20, fontWeight: "bold", marginLeft: 10, cursor: "pointer" }}
                                                        onClick={() =>
                                                            AppStateStore.setConfirmDialogContent({
                                                                content: strings.Are_you_sure_you_want_to_delete_the_selected_punch_rule,
                                                                confirm: () => this.handleChangeValue(punchRules.filter(item => item.Id !== this.state.hoveredPunchRule.Id))
                                                            })
                                                        }
                                                    />
                                                </div>
                                            }
                                        </TableRowColumn>
                                    }
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
                {this.state.openAddPunchRuleDialog &&
                    <AddPunchRuleDialog
                        existingPunchRules={punchRules}
                        editPunchRule={this.state.hoveredPunchRule}
                        handleClose={() => this.setState({ openAddPunchRuleDialog: false, hoveredPunchRule: null })}
                        handleAdd={punchRule => {
                            this.setState({
                                openAddPunchRuleDialog: false,
                                hoveredPunchRule: null
                            })
                            punchRules.push(punchRule)
                            this.handleChangeValue(punchRules)
                        }}
                        handleUpdate={punchRule => {
                            const indexOf = punchRules.findIndex(i => i.Id === punchRule.Id)
                            punchRules[indexOf] = punchRule
                            this.setState({
                                openAddPunchRuleDialog: false,
                                hoveredPunchRule: null
                            })
                            this.handleChangeValue(punchRules)
                        }}
                    />
                }
            </div>
        )
    }
}